import React from "react";
import {
  FaRegPlayCircle as PlayIcon,
  FaRegStopCircle as StopIcon,
  FaRegKeyboard as KeyboardIcon,
  FaCog as SettingsIcon,
} from "react-icons/fa";

import Scene from "../Scene.ts";
import Layers from "./layers.gui.tsx";
import LayerOptions from "./layerOptions.gui.tsx";
import ThemeToggle from "./themeToggle.gui.tsx";

export default class GUIScene extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      activeLayer,
      layers,
      layerActions,
      playing,
      togglePlay,
      onLoad,
      onSave,
      onExport,
      onShowShortcuts,
      onShowSettings,
      lastUpdate,
    } = this.props;

    return (
      <>
        <header>
          <button onClick={onLoad}>Load</button>
          <button onClick={onSave}>Save</button>
          <button onClick={onExport}>Export</button>
          <ThemeToggle />
          <button onClick={onShowShortcuts} title="Keyboard Shortcuts">
            <KeyboardIcon />
          </button>
          <button onClick={togglePlay}>
            {playing ? (
              <>
                <StopIcon /> Stop
              </>
            ) : (
              <>
                <PlayIcon /> Play
              </>
            )}
          </button>
        </header>
        <Layers
          lastUpdate={lastUpdate}
          layers={layers}
          activeLayer={activeLayer}
          onShowSettings={onShowSettings}
          {...layerActions}
        />
        <LayerOptions
          lastUpdate={lastUpdate}
          activeLayer={activeLayer}
          layerColor={activeLayer && activeLayer.color}
          {...layerActions}
        />
        <main ref={this.props.containerRef}></main>
      </>
    );
  }
}
